/* eslint-disable no-param-reassign */
import React, { useEffect } from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//  Image Skeleton
function ContentWithImageSkeleton({ htmlContent }) {
  useEffect(() => {
    const container = document.querySelector(".protip-content");
    if (container) {
      const images = container.querySelectorAll("img");
      images.forEach((img) => {
        if (!img.dataset.processed) {
          const wrapper = document.createElement("div");
          wrapper.style.position = "relative";
          wrapper.style.display = "inline-block";

          const skeletonDiv = document.createElement("div");
          skeletonDiv.innerHTML = `<div style="
            width: ${img.width || 200}px;
            height: ${img.height || 150}px;
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: loading 1.5s infinite;
            border-radius: 4px;
          "></div>`;

          img.parentNode.insertBefore(wrapper, img);
          wrapper.appendChild(skeletonDiv);
          wrapper.appendChild(img);

          // eslint-disable-next-line no-param-reassign
          img.style.display = "none";

          // eslint-disable-next-line no-param-reassign
          img.onload = () => {
            img.style.display = "block";
            skeletonDiv.remove();
          };

          img.dataset.processed = "true";
        }
      });
    }
  }, [htmlContent]);

  return (
    <div
      className="protip-content"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

// @accordion title="Your Title" defaultExpanded="true"@ details@accordion@
const ProTipContentParser = ({ rawContent }) => {
  const accordionRegex = /@accordion([^@]*)@(.*?)@accordion@/gs;

  const elements = [];
  let lastIndex = 0;

  let match;
  // eslint-disable-next-line no-cond-assign
  while ((match = accordionRegex.exec(rawContent)) !== null) {
    const beforeText = rawContent.slice(lastIndex, match.index);
    if (beforeText.trim()) {
      elements.push(
        <ContentWithImageSkeleton
          key={`text-${lastIndex}`}
          htmlContent={beforeText}
        />
      );
    }

    const attrsString = match[1]?.trim();
    const bodyHtml = match[2]?.trim();

    let title = "proTip title";
    const titleStartIndex = attrsString.indexOf('title="');
    if (titleStartIndex !== -1) {
      const titleStart = titleStartIndex + 7;
      const remainingString = attrsString.substring(titleStart);
      const titleEndMatch = remainingString.match(/"(\s+defaultExpanded=|$)/);
      if (titleEndMatch) {
        title = remainingString.substring(
          0,
          remainingString.indexOf(titleEndMatch[0])
        );
      }
    }

    const expandedMatch = attrsString.match(/defaultExpanded="(.*?)"/);
    const defaultExpanded = expandedMatch?.[1] === "true";

    elements.push(
      <Box className="accordion" key={`accordion-${match.index}`}>
        <Accordion elevation={0} defaultExpanded={defaultExpanded}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography
              component="div"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </AccordionSummary>
          <AccordionDetails>
            <ContentWithImageSkeleton htmlContent={bodyHtml} />
          </AccordionDetails>
        </Accordion>
      </Box>
    );

    lastIndex = accordionRegex.lastIndex;
  }
  const remaining = rawContent.slice(lastIndex);
  if (remaining.trim()) {
    elements.push(
      <ContentWithImageSkeleton
        key={`text-${lastIndex}`}
        htmlContent={remaining}
      />
    );
  }
  return elements;
};

export default ProTipContentParser;
